import React from "react";

import { ApiGarGarsListRequest } from "@nens/brostar/openapi-client";

import { SearchBox } from "@/components/searchbox";

import { garInformation } from "../types";

type Props = {
  searchField: keyof ApiGarGarsListRequest;
  setSearchField: (searchField: keyof ApiGarGarsListRequest) => void;
  searchString: string;
  setSearchString: (searchString: string) => void;
};

const GarFilters: React.FC<Props> = ({
  searchField,
  setSearchField,
  searchString,
  setSearchString,
}) => {
  return (
    <SearchBox
      searchField={searchField}
      setSearchField={setSearchField}
      searchString={searchString}
      setSearchString={setSearchString}
      searchOptions={garInformation}
    />
  );
};

export { GarFilters };
